import { Component, OnInit, Input, EventEmitter, Output, ViewChild, OnChanges } from '@angular/core';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { NgForm } from '@angular/forms';
import { ConfigService } from 'src/app/services/config.service';
import { TransferAccept } from 'src/app/models/shortcodes.model';
import { TransferEvent } from '../code-transfers.component';
import { Checkbox } from 'primeng/checkbox';


@Component({
  selector: 'app-accept-decline-transfers-dialog',
  templateUrl: './accept-decline-dialog.component.html',
  styleUrls: ['./accept-decline-dialog.component.scss']
})
export class AcceptDeclineDialogComponent extends ScrBaseComponent implements OnInit, OnChanges {
  @Input() fromAccountID!: string;
  @Input() transferId!: string;
  @Input() fromCompany?: string;
  @Input() scId!: number;
  @Input() leaseType = '';
  @Input() mbOptOutDate?: string;
  @Input() leaseStatus = '';
  @Input() MonthlyBilling = '';
  @Input() isMonthlyBillingEnabled = false;
  @Input() term?: number;
  @Input() expirationDate = '';
  @Input() transferStatus = '';
  @Output() transferCodeClick = new EventEmitter<TransferEvent>();
  
  transferAccept: TransferAccept= new TransferAccept();
  isDisplayMonthlyBIlling = false;
  transferAgreement = false;
  toAccountId = '';
  prepayValue = '';
  prepayRadioLabel = '';
  licenseAgreementDate?: string;
  public licenseAgreementcontent?: string;
  public bestPracticesContent?: string;
  public bestPracticesDate?: string;
  public display = false;
  isWarningVisible = false;
  public recaptchaEnabled = false;
  @ViewChild('termAgreement') termAgreementcheckbox?: Checkbox;

  @ViewChild('transferForm', { static: false }) transferForm!: NgForm;

  constructor(private shortCodesService: ShortCodesService,
    private configService: ConfigService,) { super(); }

  ngOnInit(): void {
    this.configService.getConfig().subscribe(cfg => {
      this.licenseAgreementDate = cfg.licenseAgreement.updated;
    });
    this.configService.getConfig().subscribe(cfg => {
      this.recaptchaEnabled = cfg.recaptchaEnabled;
      this.licenseAgreementDate = cfg.licenseAgreement.updated;
      this.licenseAgreementcontent = cfg.licenseAgreement.content;
      this.bestPracticesContent = cfg.bestPractices.content;
      this.bestPracticesDate = cfg.bestPractices.updated;
    });

  }
  ngOnChanges() {
    let currentTerm = this.term;
    this.prepayValue = "1";
    this.toAccountId = '';
    if (this.leaseType === "BilledMonthly") {
      currentTerm = 3;
    } else if(this.leaseType === "Prepay" && this.mbOptOutDate) {
      currentTerm = 3;
    } else if(this.leaseType === "Prepay" && !this.mbOptOutDate) {
      currentTerm = this.term;
    }
    this.prepayRadioLabel = "Prepay, Opt-in to Auto-Renew (Term: " + currentTerm?.toString() + " months)";
    this.isMonthlyBillingEnabled = this.leaseType === "BilledMonthly" && this.leaseStatus === "Approved" && this.MonthlyBilling==='1' ? true : false;
  }

  resetfrom() {
    this.isWarningVisible=false;
    this.toAccountId = '';
    this.transferAgreement = false;
    this.prepayValue = "1";
  }

  cancel() {
    this.transferForm.resetForm();
    this.transferForm.form.markAsPristine();
    this.display = false;
  }

  showDialog() {
    this.display = true;
  }

  acceptTransfer({ form }: NgForm) {
    form.controls['termAgreement'].markAsTouched();
    if (form.invalid)
      return;
    
      this.transferAccept.scId= this.scId;
      this.transferAccept.fromAccountId= parseInt(this.fromAccountID, 10);
      this.transferAccept.transferId = parseInt(this.transferId, 10);
      this.transferAccept.monthlyBilling= this.prepayValue==="3"?true:false;
      this.transferAccept.autorenew=this.prepayValue==="2"?true:false;
      this.transferAccept.transferType = this.prepayValue === "1" ? 'Prepay' : this.prepayValue === '2' ? 'Autorenew' : 'MonthlyBilling';

    this.activeSub = this.observe(this.shortCodesService.acceptTransfer(this.transferAccept), {
      onSuccess: (rsp) => {
        this.transferCodeClick.emit({type: "Success", response:rsp, scId:this.scId});
        this.display = false;
        delete this.activeSub;
      },
      onError: () => {
        this.display = false;
        delete this.activeSub;
      }
    });
  }
  declineTransfer() {

    
      this.transferAccept.scId= this.scId;
      this.transferAccept.fromAccountId = parseInt(this.fromAccountID, 10);
      this.transferAccept.transferId = parseInt(this.transferId, 10);
      this.transferAccept.monthlyBilling= this.prepayValue==="3"?true:false;
      this.transferAccept.autorenew=this.prepayValue==="2"?true:false;

   this.activeSub = this.observe(this.shortCodesService.declineTransfer(parseInt(this.transferId)), {
      onSuccess: (rsp) => {
        this.transferCodeClick.emit({type: "decline", response:rsp,scId:this.scId});
        this.display = false;
        delete this.activeSub;
        return false;
      },
      onError: () => {
        this.display = false;
        delete this.activeSub;
      }
    });
  }


  closeDialog() {
    this.display = false;
  }

  keyPressNumbers(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  displayWarning() {
    const expirationDate = new Date(this.expirationDate);
    const currentDate = new Date();
    const time = expirationDate.getTime() - currentDate.getTime();
    const dateDiff = time / (1000 * 3600 * 24);
    if (dateDiff < 5)
      this.isWarningVisible = true;
    else 
    this.isWarningVisible = false;
  }

  hideWarning() {
    this.isWarningVisible = false;
  }
}
